import Loading from '../../../Common/Loading';
import { ByCorporateAnual } from './ByCorporateAnual';
import { ByCorporateMonth } from './ByCorporateMonth';
import { ByMunicipalityAnual } from './ByMunicipalityAnual';
import { ByMunicipalityMonth } from './ByMunicipalityMonth';
import { ByDepartmentAnual } from './ByDepartmentAnual';
import { ByDepartmentMonth } from './ByDepartmentMonth';
import { ByPoliceStationAnual } from './ByPoliceStationAnual';
import { ByPoliceStationMonth } from './ByPoliceStationMonth';
import { BySituationAnual } from './bySituationAnual';
import { BySituationMonth } from './bySituationMonth';
import { usePoliceChartsDataContext } from './hooks/usePoliceChartsDataContext';
import React, { memo } from 'react';

const Graphs = memo(() => (
    <>
        <div className="charts-side-by-side-dashboards">
            <ByCorporateAnual />
            <ByCorporateMonth />
        </div>
        <div className="charts-side-by-side-dashboards">
            <BySituationAnual />
            <BySituationMonth />
        </div>
        <div className="charts-side-by-side-dashboards">
            <ByMunicipalityAnual />
            <ByMunicipalityMonth />
        </div>
        <div className="charts-side-by-side-dashboards">
            <ByPoliceStationAnual />
            <ByPoliceStationMonth />
        </div>
        <div className="charts-side-by-side-dashboards">
            <ByDepartmentAnual />
            <ByDepartmentMonth />
        </div>
    </>
));

export const Charts = () => {
    const { isLoading } = usePoliceChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Graphs />
        </>
    );
};
